import "toastr/build/toastr.min.css";
import { toast } from "react-toastify";
import { CANDIDATE_ONBOARDING } from "../config/apiEndPoint";
import { GET, POST } from "config/api.config";

const normalizeSelectOptions = (payload) => {
    const list = Array.isArray(payload)
        ? payload
        : Array.isArray(payload?.data)
            ? payload.data
            : Array.isArray(payload?.records)
                ? payload.records
                : [];

    return list
        .map((item) => {
            const value = String(
                item?.value ?? item?.id ?? item?._id ?? item?.key ?? item?.code ?? ""
            ).trim();
            const label = String(
                item?.label ??
                    item?.display ??
                    item?.data ??
                    item?.name ??
                    item?.title ??
                    value
            ).trim();
            if (!value && !label) return null;
            return { value: value || label, label: label || value };
        })
        .filter(Boolean);
};

/** GET `candidate/onboarding/meta` */
export const fetchCandidateOnboardingMetadata = async () => {
    try {
        const response = await GET(CANDIDATE_ONBOARDING.METADATA);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};

/** GET `candidate/onboarding/options/onboarding-status` */
export const fetchCandidateOnboardingStatusOptions = async () => {
    try {
        const response = await GET(CANDIDATE_ONBOARDING.ONBOARDING_STATUS_OPTIONS);
        return normalizeSelectOptions(response?.data ?? response);
    } catch (error) {
        toast.error(error?.message);
        return [];
    }
};

/** POST `candidate/onboarding/filter` */
export const submitCandidateOnboardingFilterData = async (data = {}) => {
    try {
        const response = await POST(CANDIDATE_ONBOARDING.FILTER, data);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};

/** GET `candidate/onboarding/documents/{id}` */
export const fetchCandidateOnboardingDocumentsById = async (id = "") => {
    const normalizedId = String(id ?? "").trim();
    if (!normalizedId) return null;
    try {
        const response = await GET(CANDIDATE_ONBOARDING.DOCUMENTS_BY_ID(normalizedId));
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};
